import { css, type Theme } from "@emotion/react";

import * as animations from "@styles/emotion-styles/animations";
import * as dimensions from "@styles/emotion-styles/dimensions";
import * as layers from "@styles/emotion-styles/layers";
import * as timing from "@styles/emotion-styles/timing";

export const sidebar = {
  base: (theme: Theme) => css`
    transition: all ${timing.defaultTiming} ${animations.easeOutCubic};
    background-color: ${theme.surface.level1};
    opacity: 0;
    width: 20rem;

    position: fixed;
    left: -20rem;
    top: 0px;
    height: 100%;
    z-index: ${layers.indexNavBar};

    @media only screen and (min-width: ${dimensions.desktop}) {
      display: none;
    }
  `,
  active: css`
    left: 0;
    opacity: 1;
  `,
  admin: css`
    height: calc(100%);
  `,
};
